import React from 'react';
import Select from 'react-select';
import './CustomSelectSmall.scss';
import { multiSelectStyle, DropdownIndicator } from '../../FilterV2/FilterComponent.Styles';

interface CustomSelectSmallOption {
  value: number | string;
  label: any;
}

type Props = {
  options: CustomSelectSmallOption[];
  selectValue: number | string;
  handleChange: any;
  label: any;
};

const CustomSelectSmall = (props: Props) => {
  const { options, selectValue, handleChange, label } = props;
  const selectedOption = options.find(option => option.value === selectValue) || null;
  const customSelectStyles = {
    ...multiSelectStyle,
    menuPortal: base => ({
      ...base,
      zIndex: 9999,
    }),
    menu: base => ({
      ...base,
      zIndex: 9999,
    }),
  };

  return (
    <div>
      <p className="text-custom-select">{label}</p>
      <Select
        data-testid="custom-select-small"
        value={selectedOption}
        options={options}
        isMulti={false}
        components={{ DropdownIndicator }}
        className="basic-multi-select custom-select-small"
        classNamePrefix="All"
        styles={customSelectStyles}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        placeholder=""
        onChange={value =>
          handleChange(value && !Array.isArray(value) && value.value !== undefined ? value.value.toString() : '')
        }
      />
    </div>
  );
};

export default CustomSelectSmall;
